import Vue from 'vue';
import moment from 'moment';
import {OnDemandService} from '@/services/ondemand';
import {
  GETTER_ONDEMAND_BOOKINGS,
  GETTER_ONDEMAND_LATEST_BOOKING,
  GETTER_ONDEMAND_BOOKING_DETAILS,
  GETTER_SHOW_LATEST_BOOKING_BANNER,
  MUTATE_SET_OD_BOOKING_DETAILS,
  MUTATE_SET_OD_BOOKING_LIST,
  MUTATE_HIDDEN_OD_BOOKING_ID,
  MUTATE_RESET_OD_BOOKING_DETAILS,
  ACTION_SET_OD_BOOKING_DETAILS,
  ACTION_GET_OD_BOOKINGS,
  ACTION_SET_HIDDEN_OD_BOOKING_ID,
  ACTION_RESET_OD_BOOKING_DETAILS,
} from './types';
import {isCampaignOnDemandVideo} from '@leapfroggr/patientappcommons/dist/modules/on-demand';
import {saveHiddenOdBookingId, getHiddenOdBookingId} from '@/utils/on-demand';
import {logger} from '@/utils/logger';

const defaultState = () => ({
  bookingDetails: null,
  bookingList: [],
  hiddenODBookingId: getHiddenOdBookingId() || '',
});

const state = defaultState();

const getters = {
  [GETTER_ONDEMAND_BOOKINGS]: ({bookingList}) => {
    return bookingList.filter(booking => isCampaignOnDemandVideo(booking.campaignid));
  },
  [GETTER_ONDEMAND_LATEST_BOOKING]: ({bookingList}) => {
    const latest = bookingList.length ? bookingList[0] : null;

    if (latest) {
      return moment().diff(moment(latest.bookingdate), 'hours') <= 2
        ? latest
        : null;
    }

    return null;
  },
  [GETTER_SHOW_LATEST_BOOKING_BANNER]: (state, getters) => {
    if (!getters[GETTER_ONDEMAND_LATEST_BOOKING]) return false;

    return getters[GETTER_ONDEMAND_LATEST_BOOKING]._id !== state.hiddenODBookingId;
  },
  // for OD status page
  [GETTER_ONDEMAND_BOOKING_DETAILS]: ({bookingDetails}) => bookingDetails,
};

const mutations = {
  [MUTATE_SET_OD_BOOKING_DETAILS](state, details) {
    Vue.set(state, 'bookingDetails', details);
  },
  [MUTATE_HIDDEN_OD_BOOKING_ID](state, bookingId) {
    Vue.set(state, 'hiddenODBookingId', bookingId);
  },
  [MUTATE_SET_OD_BOOKING_LIST](state, data) {
    Vue.set(state, 'bookingList', data);
  },
  [MUTATE_RESET_OD_BOOKING_DETAILS](state) {
    Vue.set(state, 'bookingDetails', null);
  },
};

const actions = {
  [ACTION_SET_OD_BOOKING_DETAILS]({commit}, details) {
    commit(MUTATE_SET_OD_BOOKING_DETAILS, details);
  },
  [ACTION_SET_HIDDEN_OD_BOOKING_ID]({commit}, bookingId) {
    commit(MUTATE_HIDDEN_OD_BOOKING_ID, bookingId);
    saveHiddenOdBookingId(bookingId);
  },
  async [ACTION_GET_OD_BOOKINGS]({commit}) {
    try {
      const {data} = await OnDemandService.getOnDemandBookings();

      if (data.result === 1) {
        commit(MUTATE_SET_OD_BOOKING_LIST, data.bookings);
      } else {
        logger.warn('ACTION_GET_OD_BOOKINGS non-success result', {result: data.result});
      }
    } catch (error) {
      // Preserve last-known-good bookingList on failure; interval will retry.
      logger.error('ACTION_GET_OD_BOOKINGS XHR failed', {}, error);
      throw error;
    }
  },
  [ACTION_RESET_OD_BOOKING_DETAILS]({commit}) {
    commit(MUTATE_RESET_OD_BOOKING_DETAILS);
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};
